import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const shelfDefaultVariants = {}
const shelfCompoundVariants = []

const shelfSlotNames = [
  [
    "root",
    "Shelf__root"
  ],
  [
    "top",
    "Shelf__top"
  ],
  [
    "topLeft",
    "Shelf__topLeft"
  ],
  [
    "topCenter",
    "Shelf__topCenter"
  ],
  [
    "topRight",
    "Shelf__topRight"
  ],
  [
    "middle",
    "Shelf__middle"
  ],
  [
    "middleLeft",
    "Shelf__middleLeft"
  ],
  [
    "middleCenter",
    "Shelf__middleCenter"
  ],
  [
    "middleRight",
    "Shelf__middleRight"
  ],
  [
    "left",
    "Shelf__left"
  ],
  [
    "center",
    "Shelf__center"
  ],
  [
    "right",
    "Shelf__right"
  ],
  [
    "bottom",
    "Shelf__bottom"
  ],
  [
    "bottomLeft",
    "Shelf__bottomLeft"
  ],
  [
    "bottomCenter",
    "Shelf__bottomCenter"
  ],
  [
    "bottomRight",
    "Shelf__bottomRight"
  ]
]
const shelfSlotFns = /* @__PURE__ */ shelfSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, shelfDefaultVariants, getSlotCompoundVariant(shelfCompoundVariants, slotName))])

const shelfFn = memo((props = {}) => {
  return Object.fromEntries(shelfSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const shelfVariantKeys = []
const getVariantProps = (variants) => ({ ...shelfDefaultVariants, ...compact(variants) })

export const shelf = /* @__PURE__ */ Object.assign(shelfFn, {
  __recipe__: false,
  __name__: 'shelf',
  raw: (props) => props,
  variantKeys: shelfVariantKeys,
  variantMap: {},
  splitVariantProps(props) {
    return splitProps(props, shelfVariantKeys)
  },
  getVariantProps
})